// extracted by mini-css-extract-plugin
export default {"audio_player_head_playing_bar":"bd925c","time":"df7adc","volume_bar":"da6e9c"};